import memoizeOne from "memoize-one";
import { IStore } from "reducers";
import { IState as IMerchantCollectionVersionStatusState } from "reducers/merchant-collection-version-status";
import { ICollectionVersionStatus } from "helpers/collection-version-status";

export const getMerchantCollectionVersionStatusState = (state: IStore): IMerchantCollectionVersionStatusState => {
    return state.merchantCollectionVersionStatus;
};

export const getMerchantCollectionVersionStatusList = (state: IStore): ICollectionVersionStatus[] => {
    return getMerchantCollectionVersionStatusState(state).list.result;
};

const filterActiveMerchantCollectionVersionStatus = memoizeOne(
    (merchantCollectionVersionStatutes: ICollectionVersionStatus[]) => {
        return merchantCollectionVersionStatutes.filter(
            (merchantCollectionVersionStatut) => merchantCollectionVersionStatut.enabled
        );
    }
);
export const getActiveMerchantCollectionVersionStatus = (state: IStore) => {
    return filterActiveMerchantCollectionVersionStatus(getMerchantCollectionVersionStatusList(state));
};
